<template>
  <router-link :to="{ name: 'home' }">
    <img
      :src="require('@/assets/images/logo.png')"
      style="max-width: 413px; width: 100% !important; height: auto !important"
      border="0"
      alt="Renters Insurance by NSSI"
    />
  </router-link>
</template>
